import loadScript from 'load-script';

let loaded = false;

/**
 * This module / function allows the dynamic loading of google client
 * javascript library
 * @param  {String}   prebidUrl - the url for prebid sdk (depending of each brand)
 * @param  {Function} callback - the function to execute once google client api is loaded
 * @param  {Object}   options  - options for the loading of the script
 * @return {void}
 */
export default function (prebidUrl, callback = null, options = {}) {
  if (loaded && typeof callback === 'function') {
    callback();
    return false;
  }

  if (loaded) {
    return false;
  }

  loadScript(prebidUrl, options, () => {
    loaded = true;
    if (typeof callback === 'function') {
      callback();
    }
  });
}
